export const PLATFORM_NAME = 'visionplatform.ai'

export const VP_DOCS_URL = 'https://docs.visionplatform.ai'
export const VP_LEGAL_TERMS_URL = 'https://legal.frontiergroup.ai'
export const VP_NO_REPLY_EMAIL = 'no-reply@visionplatform.ai'
export const VP_CONTACT_EMAIL = 'info@visionplatform.ai'
export const VP_CONTACT_PHONE = '+31 85 06 06 591'

export const VP_API_BASE_URL = import.meta.env.VITE_VP_API_BASE_URL

export const REACT_QUERY_DEVTOOLS_ENABLED = import.meta.env
  .VITE_REACT_QUERY_DEVTOOLS_ENABLED

export const SCENARIO_SIMULATOR_QUERY_PARAM = 'scenario'

export const CHATBOT_CHATFLOWID = import.meta.env.VITE_CHATBOT_CHATFLOWID
export const CHATBOT_APIHOST = import.meta.env.VITE_CHATBOT_APIHOST

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
export const SENTRY_ENABLED = import.meta.env.VITE_SENTRY_ENABLED

export const ENV_NAME = import.meta.env.VITE_ENV_NAME

export const EDGE_CLIENT_VERSION_FILE = import.meta.env
  .VITE_EDGE_CLIENT_VERSION_FILE

export const TOWER_VERSION_FILE = import.meta.env.VITE_TOWER_VERSION_FILE
export const TRACKING_VERSION_FILE = import.meta.env.VITE_TRACKING_VERSION_FILE

export const TRAINING_UNDER_MAINTENANCE = import.meta.env
  .VITE_TRAINING_UNDER_MAINTENANCE

export const DEV_VLM_PIPELINES_ENABLED =
  import.meta.env.VITE_DEV_VLM_PIPELINES_ENABLED === 'true'

export const ALLOWED_LOGIN_EXTERNAL_REDIRECT = import.meta.env
  .VITE_ALLOWED_LOGIN_EXTERNAL_REDIRECT

// Zoho form URLs
export const ZOHO_FEEDBACK_FORM_URL = 'https://survey.zohopublic.eu/zs/sXTGGp'

export const ZOHO_REQUEST_LABELING_FORM_URL =
  'https://survey.zohopublic.eu/zs/3PxuV6'

export const ZOHO_LICENSE_UPGRADE_FORM_URL =
  'https://survey.zohopublic.eu/zs/SwEFjF'
